var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.663,
    height: 26.5,
    viewBox: "0 0 26.663 26.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    transform: "translate(0.25 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321",
    transform: "translate(0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    d: "M.572,0H24.591a.572.572,0,0,1,.572.572V5.3a.573.573,0,0,1-.573.573H.572A.572.572,0,0,1,0,5.3V.572A.572.572,0,0,1,.572,0Z",
    transform: "translate(0 19.127)",
    fill: "#d7e0ff",
    stroke: "#0182f0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M1.435,10.118,13.019.53,24.6,10.118Z",
    transform: "translate(-0.412 -0.53)",
    fill: "#d7e0ff",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323",
    transform: "translate(3.688 9.588)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_90",
    "data-name": "Line 90",
    y2: 8.993,
    transform: "translate(0 0.228)",
    fill: "none",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_91",
    "data-name": "Line 91",
    y2: 8.993,
    transform: "translate(5.47)",
    fill: "none",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_93",
    "data-name": "Line 93",
    y2: 8.993,
    transform: "translate(13.035)",
    fill: "none",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_92",
    "data-name": "Line 92",
    y2: 8.993,
    transform: "translate(18.599 0.228)",
    fill: "none",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankInfoIcon);
export default __webpack_public_path__ + "static/media/bank-info-icon.7168dbad72ee4bfbf554b6c69e37172d.svg";
export { ForwardRef as ReactComponent };